<div class="survey-viewer__container">
  <div class="survey-viewer__content" @openingAnimation>
    @if (isTestMode$() && !previewMode()) {
      <div class="survey-viewer__test">
        <div class="survey-viewer__test__banner">
          <fa-icon [icon]="faMessageExclamation"></fa-icon>
          <div class="survey-viewer__test__banner__text">
            <span class="text__sm fw__500">Test</span>
          </div>
        </div>
      </div>
    }

    @if (showEndPage$()) {
      <empathy-end-page-view class="survey-viewer__survey" [endPage]="startSurvey().endPage" (completed)="onComplete()"></empathy-end-page-view>
    } @else if (showFeedbackPage$()) {
      <empathy-feedback-view (submit)="onSubmitFeedback($event)"></empathy-feedback-view>
    } @else {
      @if (!isPreparing$()) {
        @if (!!welcomeDetails$()) {
          <empathy-welcome-page-view [welcomeDetails]="welcomeDetails$()" (start)="onStart()"></empathy-welcome-page-view>
        } @else {
          <empathy-page-view
            class="survey-viewer__survey"
            [completionPending]="completionPending$()"
            [page]="activePage$()"
            [chatState]="activePageChatState$()"
            [previewMode]="previewMode()"
            [resumeAnswers]="resumeAnswers$()"
            (httpError)="onHandleCommunicationError()"
            (prev)="onPrev()"
            (next)="onNext()"
          ></empathy-page-view>
        }
      }
    }
  </div>
</div>
